const KEY = 'ipp:notice-banner-dismissed'

export const readDismissed = (): Record<string, string> => {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? (JSON.parse(raw) as Record<string, string>) : {}
  } catch {
    return {}
  }
}

export const dismiss = (id: string, updatedAt: string): void => {
  const map = readDismissed()
  map[id] = updatedAt
  localStorage.setItem(KEY, JSON.stringify(map))
}

export const isDismissed = (id: string, updatedAt: string): boolean =>
  readDismissed()[id] === updatedAt
